import { useMemo } from "react";
import { useCachedMedium } from "./useCachedMedium";
import { useCachedTerreiro } from "./useCachedTerreiro";

export type NotificationOwnerScope = {
  terreiroId?: string;
  mediumId?: string;
};

/**
 * XOR owner scope for notification inbox queries.
 * Terreiro profile wins; personal profile uses the cached medium.
 */
export function useNotificationOwnerScope(): NotificationOwnerScope {
  const cachedTerreiro = useCachedTerreiro();
  const cachedMedium = useCachedMedium();
  const terreiroId = cachedTerreiro?.id;
  const mediumId = cachedMedium?.id;

  return useMemo(() => {
    if (terreiroId) {
      return { terreiroId };
    }

    if (mediumId) {
      return { mediumId };
    }

    return {};
  }, [terreiroId, mediumId]);
}
